import {fetch} from "utils/dataAccess";

export default function mappingStats(params) {
    const query = params ? `?${params}` : '';

    return fetch(`/products/mapping-stats${query}`).then((response) => response.json());
}
